<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_12_1936)">
      <path
        d="M14.0909 20.5909C14.6181 20.0637 14.6181 19.209 14.0909 18.6818C13.5638 18.1546 12.709 18.1546 12.1818 18.6818C11.6547 19.209 11.6547 20.0637 12.1818 20.5909C12.709 21.1181 13.5638 21.1181 14.0909 20.5909Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.8182 5.31819C13.3454 4.79101 13.3454 3.93628 12.8182 3.4091C12.291 2.88192 11.4363 2.88192 10.9091 3.4091C10.382 3.93628 10.382 4.79101 10.9091 5.31819C11.4363 5.84538 12.291 5.84538 12.8182 5.31819Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.3606 15.7758L18.8424 13.2939C19.3544 12.782 19.6442 12.0899 19.6482 11.3698C19.6522 10.6498 19.37 9.96087 18.8637 9.45454C18.3573 8.94822 17.6684 8.66601 16.9484 8.66998C16.2283 8.67396 15.5362 8.96381 15.0243 9.47576L10.6121 13.8879C10.1002 14.3998 9.40807 14.6897 8.68805 14.6937C7.96802 14.6976 7.27906 14.4154 6.77274 13.9091C6.26642 13.4028 5.9842 12.7138 5.98818 11.9938C5.99216 11.2738 6.282 10.5816 6.79395 10.0697L8.72426 8.13939"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_12_1936">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>